import { ChangeEvent } from "react"
import Button from "components/Buttons/Button"
import { makeStyles } from "makeStyles"
import { NativeSelect, FormControl } from "@mui/material"
import { SeriesModel } from "utils/commerceTools/formatters/formatSeries"

import useScrollPosition from "@secureo/common/hooks/useScrollPosition"
// import Scrollspy from "react-scrollspy"

const useStyles = makeStyles()((theme) => ({
	displayNone: {
		display: "none",
	},
	stickyNav: {
		background: "#082129",
		color: "#fff",

		zIndex: 2,
		position: "fixed",
		top: 0,
		left: 0,
		width: "100%",
	},

	// dropdown
	formControl: {
		margin: theme.spacing(1),
		minWidth: 120,
	},
	selectEmpty: {
		marginTop: theme.spacing(2),
	},
	icon: {
		color: "white",
	},
	// scrollspy
	button: {
		borderRadius: 30,
		padding: 5,
		paddingLeft: 16,
		paddingRight: 16,
		marginRight: 14,
		textTransform: "inherit",
		fontWeight: 800,
		fontSize: 14,
		whiteSpace: "nowrap",
		textDecoration: "none",
	},
	scrollSpy: {
		"& $button": {
			background: theme.palette.primary.main,
			color: "white",
		},
	},
}))

const StickySeriesNav = ({ modelSku, setModelSku, models }: Props) => {
	const { classes } = useStyles()
	const hasModels = models.length > 1

	const onChange = (
		event: ChangeEvent<{
			value: string
		}>,
	) => {
		setModelSku(event.target.value)
	}

	const { scrollY } = useScrollPosition()

	const model = models.find((model) => model.sku === modelSku)

	return (
		<div className={scrollY > 80 ? classes.stickyNav : classes.displayNone}>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					padding: "10px 16px 10px 16px",
				}}
			>
				{hasModels ? (
					<FormControl variant="outlined" className={classes.formControl}>
						<NativeSelect
							value={modelSku}
							onChange={onChange}
							inputProps={{
								name: "model",
							}}
							classes={{
								icon: classes.icon,
							}}
							style={{ color: "white" }}
						>
							{models.map((model) => {
								if (!model) return null
								const { sku, name } = model

								return (
									<option key={sku} value={sku}>
										{name}
									</option>
								)
							})}
						</NativeSelect>
					</FormControl>
				) : (
					<p>{model.name}</p>
				)}
				<Button color="primary" style={{ maxWidth: 150 }}>
					Wo kaufen?
				</Button>
			</div>
		</div>
	)
}

interface Props {
	modelSku: string
	setModelSku: (sku: string) => void
	models: SeriesModel[]
	hasTechnicalDetails: boolean
	hasDescription: boolean
	hasLockVariants: boolean
	hasOverview: boolean
}

export default StickySeriesNav
